import { RECEIVED_ACCOUNT_HISTORY } from 'state/account/IndividualAccountActions';

export const accountHistory = (state = {}, action) => {
  if (action.type === RECEIVED_ACCOUNT_HISTORY) {
    if (action.history.length > 0) {
      const history = action.history[0];
      return {
        ...history,
        deductions: -Math.abs(history.deductions)
      };
    }
    return {};
  }
  return state;
};
